export type Coupon = {
  code: string
  value: string | number
}

export function getInsufficientCapacityCoupon(): Coupon {
  return {
    code: 'RenderroCloud50',
    value: '50',
  }
}
